import React, { useState } from "react";
import { patchGroupParticipant } from "../../services/httpClient";
import { Card, Stack } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faClose, faTrash } from "@fortawesome/free-solid-svg-icons";
import IconButton from "../ui/IconButton";

interface GroupCardState {
  group: any;
  editMode: boolean;
  setUserFields: any;
  groups: any[];
  setAvailableGroups: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const GroupCard = ({
  group,
  editMode,
  setUserFields,
  groups,
  setAvailableGroups,
  setShowToast,
  setToastText,
  setToastBody,
}: GroupCardState) => {
  const [isRemovingGroup, setIsRemovingGroup] = useState(false);

  const onClickRemoveGroup = () => {
    setIsRemovingGroup(true);
  };

  const onClickCancelRemove = () => {
    setIsRemovingGroup(false);
  };

  const onClickRemoveFinal = () => {
    if (editMode) {
      patchGroupParticipant(group?.id, group?.group_participant_id).then((res: any) => {
        setUserFields((prev: any) => {
          const updatedUserGroups = prev?.groups?.filter((g: any) => g?.id !== group?.id);
          const userGroupIds = new Set(updatedUserGroups?.map((g: any) => g.id));
          const available = groups.filter((g: any) => !userGroupIds.has(g.id));
          setAvailableGroups(available);

          const updated = { ...prev, groups: updatedUserGroups };
          return updated;
        });

        setIsRemovingGroup(false);
        setShowToast(true);
        setToastText("Group Removed");
        setToastBody(group?.name);
      });
    } else {
      setUserFields((prev: any) => {
        const updatedUserGroups = prev?.groups?.filter((g: any) => g?.id !== group?.id);
        const userGroupIds = new Set(updatedUserGroups?.map((g: any) => g.id));
        const available = groups.filter((g: any) => !userGroupIds.has(g.id));
        setAvailableGroups(available);

        const updated = { ...prev, groups: updatedUserGroups };
        return updated;
      });
      setIsRemovingGroup(false);
    }
  };

  return (
    <Card key={group.id} className="bg-light mb-2">
      <Card.Body>
        <Stack direction="horizontal" gap={3}>
          {isRemovingGroup ? (
            <>
              <Stack style={{ justifyContent: "center" }} gap={2}>
                <Card.Subtitle>Remove</Card.Subtitle>
                <Card.Subtitle>{group.name}?</Card.Subtitle>
              </Stack>
              <FontAwesomeIcon className="text-muted me-1 cursor-pointer" icon={faCheck} onClick={() => onClickRemoveFinal()} />
              <div className="vr" />
              <FontAwesomeIcon className="text-muted me-1 cursor-pointer" icon={faClose} onClick={() => onClickCancelRemove()} />
            </>
          ) : (
            <>
              <Stack gap={2} className="align-self-center">
                <Card.Subtitle className="text-muted">
                  <small>{group.name}</small>
                </Card.Subtitle>
              </Stack>
              <IconButton onClickButton={onClickRemoveGroup} tooltipText={"Remove"} icon={faTrash} />
            </>
          )}
        </Stack>
      </Card.Body>
    </Card>
  );
};

export default GroupCard;
